<template>
    <div>
        <form @submit.prevent="submitForm">
            <h3>Logout?</h3>
            <button class="button">Confirm</button>
        </form>
    </div>
</template>

<script>
import { app } from "../main.js";

export default {
    methods: {
        submitForm() {
            app.config.globalProperties.$displayName = "";
            app.config.globalProperties.$idToken = "";
            app.config.globalProperties.$expiresIn = "";
            app.config.globalProperties.$authenticated = false;
            this.$router.replace("/login");               
        },
    },
};
</script>

<style scoped>
div {
    background: skyblue;
    padding: 10px;
    margin: 5px;
    text-align: center;
    font-family: Arial, Helvetica, sans-serif;
}

.button {
    background-color: white;
    border: 3p;
    border-color: #4caf50;
    color:#4caf50;
    font-family:Arial, Helvetica, sans-serif;
    border-radius: 3px;
    font-size: 1rem;
}

.button:hover {
    background-color:#4caf50;
    border: 3p;
    color:white;
    font-family:Arial, Helvetica, sans-serif;
    border-radius: 3px;
    font-size: 1rem;
}
</style>